export default {
      id: "settings-arrow-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#settings-arrow-usage",
      toString: function () {
        return this.url;
      }
    }